module.exports = __webpack_public_path__ + "img/k12_room1.a3a74b6e.png";